// Get Lookbooks
export const GET_LOOKBOOKS_REQUEST = 'GET_LOOKBOOKS_REQUEST';
export const GET_LOOKBOOKS_DONE = 'GET_LOOKBOOKS_DONE';
export const GET_LOOKBOOKS_FAILED = 'GET_LOOKBOOKS_FAILED';
export const GET_LOOKBOOKS_RESET = 'GET_LOOKBOOKS_RESET';

// Operations
export const TOGGLE_LOOKBOOK = 'TOGGLE_LOOKBOOK';
export const TOGGLE_ALL_LOOKBOOKS = 'TOGGLE_ALL_LOOKBOOKS';
export const SET_LOOKBOOKS_FILTER = 'SET_LOOKBOOKS_FILTER';
export const SET_LOOKBOOKS_ALL_FILTERS = 'SET_LOOKBOOKS_ALL_FILTERS';
export const CLEAR_LOOKBOOKS_FILTERS = 'CLEAR_LOOKBOOKS_FILTERS';
export const LOOKBOOKS_SET_PAGE = 'LOOKBOOKS_SET_PAGE';